var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_960_28101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3334 11.1478H9.80672L9.62005 10.9454C10.4201 9.89596 10.8334 8.46425 10.6067 6.94259C10.2934 4.85874 8.74672 3.19466 6.88005 2.9398C4.06005 2.55002 1.68672 5.21854 2.03338 8.38929C2.26005 10.4881 3.74005 12.2272 5.59338 12.5795C6.94672 12.8343 8.22005 12.3696 9.15338 11.4701L9.33338 11.68V12.2721L12.1667 15.4579C12.4401 15.7652 12.8867 15.7652 13.1601 15.4579C13.4334 15.1506 13.4334 14.6483 13.1601 14.341L10.3334 11.1478ZM6.33338 11.1478C4.67338 11.1478 3.33338 9.6411 3.33338 7.77463C3.33338 5.90816 4.67338 4.4015 6.33338 4.4015C7.99338 4.4015 9.33338 5.90816 9.33338 7.77463C9.33338 9.6411 7.99338 11.1478 6.33338 11.1478Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_960_28101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 17.99,
    fill: "white",
    transform: "translate(0 0.653564)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.cae09fb19ac7c9215873785c3a399cda.svg";
export { ForwardRef as ReactComponent };